import styled from 'styled-components';
import color from '../../../config/colors.json';
import BannerTabletBg from '../../../img/banner_tablet.png';
import ScreenSize from '../../../config/screenSizes.json';
import elipse from '../../../img/elipse.png';

export const BannerBackground = styled.div`
    height: 259px;
    background-color: #2F3132;
    border-radius: 5px;
    position: relative;
    padding-left: 77px;
    background-image: url('${elipse}');
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-position: calc(100% - 200px) 100%;

    img {
        margin-top: 49px;
        margin-right: 25px;
        float: right;
    }

    @media screen and (max-width: 1919px) {
    height: 190px;
    }  

    @media screen and (max-width: ${ScreenSize.tablet}px) {
        background-image: none;
        height: 150px;
        background-image: url('${elipse}');
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: calc(100% - 110px) 100%;
    }

    @media screen and (max-width: ${ScreenSize.portrait}px) {
        background-image: none;
        height: 150px;
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: calc(100% - 110px) 100%;
    }
`;

export const Banner = styled.div`
    position: relative;
    padding: 21px 33px;
    border-radius: 5px;
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        background-image: url('${BannerTabletBg}');
        background-size: auto;
        background-position: top right;
    }
`;

export const MainText = styled.h1`
    color: ${color.light};
    font-size: 27px;
    line-height: 37px;
    font-weight: bold;
    font-family: 'Poppins', sans-serif;
    @media screen and (max-width: 1919px) {
        font-size: 20px;
    }  
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 18px;
    }
`;

export const Title = styled.h1`
    font-size: 25px;
    line-height: 49px;
    text-transform: uppercase;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    color: ${color.light};
    margin-bottom: 20px;
    position: relative;
    &:after {
        content: '';
        display: table;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 113px;
        height: 3px;
        background-color: ${color.lightRed};
    }
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 28px;
        margin-bottom: 25px;
    }
`;

export const Text = styled.em`
    margin-bottom: 18px;
    display: block;
    font-style: normal;
    font-size: 15px;
    line-height: 25px;
    font-family: 'Poppins', sans-serif;
    color: ${color.light};
    @media screen and (max-width: 1919px) {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
  }  
    @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 0;
    }
`;

export const CarImg = styled.img`
    position: absolute;
    top: ${({ top }) => top};
    right: ${({ right }) => right};
    z-index: 1;
    &:nth-of-type(1) {
        top: 10px;
        right: 347px;
     }
     &:nth-of-type(2) {
        top: 30px;
        right: 83px;
     }
    @media screen and (max-width: 1919px) {
    width: 30%;
    &:nth-of-type(1) {
        top: 10px;
        right: 226px;
     }
     &:nth-of-type(2) {
        top: 15px;
        right: 39px;
     }
  }  
  @media screen and (max-width: ${ScreenSize.tablet}px) {
    width: 30%;
    &:nth-of-type(1) {
        top: 26px;
        right: 120px;
     }
     &:nth-of-type(2) {
        top: 35px;
        right: 0;
     }
  }  
  @media screen and (max-width: ${ScreenSize.portrait}px) {
    display: none;
  }
`;
